import React from "react";
import Render from "@gqlapp/theme";
import template from "./home.html.twig";
import { sharedPartials } from "@modules/layout/partials";
import Slideshow from "@lib/components/Slideshow";
import { fetchMenu, fetchList } from "@lib/content/fetch";
import { toTeasers } from "@lib/content/normalize";
import ARTICLES_QUERY from "@modules/article/graphql/ArticlesQuery.graphql";
import VIDEOS_QUERY from "@modules/video/graphql/VideosQuery.graphql";

const SLIDES = [
	'http://vinhxuanhaiphong.vn/files/slide/1st.jpg',
	'http://vinhxuanhaiphong.vn/files/slide/2nd.jpg',
	'http://vinhxuanhaiphong.vn/files/slide/3rd.jpg',
	'http://vinhxuanhaiphong.vn/files/slide/4th.jpg',
	'http://vinhxuanhaiphong.vn/files/slide/5th.jpg',
];

const EMPTY_HOME = { slides: SLIDES, categories: [], popular: [], latest: [], more: [], media: [] };

export default function HomeContainer(props: any){
	const { homeData } = props;
	return <>
		<Render {...{ template, context: { partials: { ...sharedPartials }, Slideshow, ...EMPTY_HOME, ...(homeData || {}) } }} />
	</>;
}

HomeContainer.getInitialProps = async ({ apolloClient }: any) => {
	if (!apolloClient) return { homeData: EMPTY_HOME };

	const safe = async (task: Promise<any>, fallback: any) => {
		try { return await task; } catch (e) { debug(e); return fallback; }
	};
	const list = (query: any, args: any, opts?: any) => safe(
		fetchList(apolloClient, query, args).then(({ edges }) => toTeasers(edges, opts)), []
	);

	const [popular, latest, more, media, categories] = await Promise.all([
		list(ARTICLES_QUERY, { page: 1, pageSize: 10, filter: { tids: [34] } }, { imageLeft: true }),
		list(ARTICLES_QUERY, { page: 1, pageSize: 3, filter: { tids: [3], promote: true } }),
		list(ARTICLES_QUERY, { page: 1, pageSize: 10, filter: { tids: [3], promote: true } }),
		list(VIDEOS_QUERY, { page: 1, pageSize: 6 }),
		safe(fetchMenu(apolloClient, 'article'), []),
	]);

	return { homeData: { slides: SLIDES, categories, popular, latest, more, media } };
};
